<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Observatory</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-card-header>
          <h3 class="mb-0">Observable Agents</h3>
        </b-card-header>
        <observable-table :tableData="items"></observable-table>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import ObservableTable from '@/views/Components/Tables/ObservableTable';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [errorsMixin],
  components: {
    RouteBreadCrumb,
    ObservableTable
  },
  data() {
    return {
      items: null,
    }
  },
  computed: {
    userRoute() {
     return this.$store.getters['profile/userRoute'];
    }
  },
  methods: {
    getItems() {
      axios.get(this.userRoute + "/observable-users")
      .then(response => {
        this.items = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    }
  },
  created() {
    this.getItems();
  }
};
</script>